import { graphql, readInlineData } from "react-relay";
import { scmpPlus } from "scmp-sdk";

import { section as sectionData } from "shared/data";
import { article as articleData } from "shared/data/article";
import { notEmpty } from "shared/lib/utils";

import {
  checkArticleIsInSections,
  getArticleType,
} from "scmp-app/components/article/article-render/helpers";
import { checkIsStyleArticle } from "scmp-app/components/article/article-render/style-article/helper";
import { getContentSponsor } from "scmp-app/components/content/content-sponsor-tag/helpers";
import type { helpersCheckCanShowInPlusPlatformContent$key } from "scmp-app/queries/__generated__/helpersCheckCanShowInPlusPlatformContent.graphql";
import type { helpersCheckIsPlusArticle$key } from "scmp-app/queries/__generated__/helpersCheckIsPlusArticle.graphql";

export const checkIsPlusArticle = (reference: helpersCheckIsPlusArticle$key) => {
  const article = readInlineData(
    graphql`
      fragment helpersCheckIsPlusArticle on Content @inline {
        ... on Article {
          paywallTypes {
            entityUuid
          }
        }
      }
    `,
    reference,
  );

  const paywallTypes = article?.paywallTypes?.map(paywallType => paywallType?.entityUuid);

  return notEmpty(paywallTypes?.includes(scmpPlus.article.paywallTypeId));
};

export const checkIsContainsPlusQueryString = (
  query: Record<string, string | string[] | undefined>,
) => {
  const { articleId, display } = query;
  if (notEmpty(articleId) && display === "plus") {
    return true;
  }
};

const allowedInPlusPlatformTypes = new Set<string>([
  articleData.types.betweenTheLines.entityId,
  articleData.types.chinaFutureTechBriefing.entityId,
  articleData.types.column.entityId,
  articleData.types.dailyPulseBriefing.entityId,
  articleData.types.factSheet.entityId,
  articleData.types.opinion.entityId,
]);
export const checkCanShowInPlusPlatform = (
  reference: helpersCheckCanShowInPlusPlatformContent$key,
) => {
  const content = readInlineData(
    graphql`
      fragment helpersCheckCanShowInPlusPlatformContent on Content @inline {
        __typename
        ...helpersCheckArticleIsInSectionsArticle
        ...helpersCheckIsPlusArticle
        ...helpersCheckIsStyleArticle
        ...helpersGetArticleTypeArticle
        ...helpersUseContentSponsorContent
      }
    `,
    reference,
  );

  if (content.__typename !== "Article") return false;
  else if (checkIsPlusArticle(content)) return true;
  else if (
    checkIsStyleArticle(content) ||
    checkArticleIsInSections(content, [
      sectionData.posties.entityId,
      sectionData.spark.entityId,
      sectionData.youngPost.entityId,
      sectionData.yp.entityId,
    ]) ||
    notEmpty(getContentSponsor(content)?.name)
  )
    return false;

  const articleType = getArticleType(content);
  const isAllowedTypes = articleType === undefined || allowedInPlusPlatformTypes.has(articleType);
  return isAllowedTypes;
};
